import apolloClient from "../apolloClient";
import { GET_SUBSCRIPTION_PRODUCTS } from "./graphql";

class SubscriptionProductService {
	async getProducts() {
		const { data } = await apolloClient.query({
			query: GET_SUBSCRIPTION_PRODUCTS,
		});

		return data.variants.nodes;
	}
}

export default new SubscriptionProductService();
